module.exports = ['$sce', '$filter', function ($sce, $filter) {
    return {
        restrict: "E",
        templateUrl: '/static/partials/components/editable_text_field.html',
        scope: {
            pdModel: "=",
            pdOnSave: "&"
        },
        replace: true,
        // transclude: true,
        controller: ['$scope', function ($scope) {
            this.editMode = false;
            this.editValue = "";
            this.saving = false;

            this.startEdit = () => {
                this.editMode = true;
                this.editValue = $scope.pdModel;
            };

            this.cancel = () => {
                this.editMode = false;
                this.editValue = $scope.pdModel;
            };

            this.save = () => {
                if (this.saving) {
                    return;
                }

                this.editMode = false;
                this.saving = true;
                var promise = $scope.pdOnSave({value: this.editValue});

                if (promise) {
                    promise.finally(() => {
                        this.saving = false;
                    })
                }
            };
        }],
        controllerAs: "editable_field",
        link: function link($scope, $element, $attrs, controller) {

        }
    };
}];